import { render, staticRenderFns } from "./message-group-system.vue?vue&type=template&id=23701448&scoped=true"
import script from "./message-group-system.vue?vue&type=script&lang=ts"
export * from "./message-group-system.vue?vue&type=script&lang=ts"
import style0 from "./message-group-system.vue?vue&type=style&index=0&id=23701448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23701448",
  null
  
)

export default component.exports